import Vue from 'vue'
import VueTinyLazyload from '../custom/vue-tiny-lazyload-img/index'

Vue.use(VueTinyLazyload)
